import { Client } from "../types/ganttChart";

export const formatCitizenAddress = (client?: Client): string | undefined => {
  if (!client) return undefined;
  const parts = [client.address, client.district].filter(
    (part): part is string => Boolean(part && part.trim()),
  );
  return parts.length > 0 ? parts.join(", ") : undefined;
};

export const getCitizenAddress = (
  clients: Client[],
  serviceClientId: number,
): string | undefined =>
  formatCitizenAddress(
    clients.find((client) => client.idServiceClient === serviceClientId),
  );
